import { render } from "./PaymentsEdit.vue?vue&type=template&id=3a962360&scoped=true"
import script from "./PaymentsEdit.vue?vue&type=script&lang=js"
export * from "./PaymentsEdit.vue?vue&type=script&lang=js"

import "./PaymentsEdit.vue?vue&type=style&index=0&id=3a962360&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a962360"]])

export default __exports__